/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link, useNavigate } from "react-router-dom";
import { GetService, PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { BounceLoader } from "react-spinners";
import { ImageURL } from "../../../Environment/Environment";
import { useCart } from "../../CartContext";

export default function AddToCart() {
  const navigate = useNavigate();

  const [CartList, setCartList] = useState([]);
  const [CardSummary, setCardSummary] = useState([]);
  const [loading, setLoading] = useState(false);

  const [quantities, setQuantities] = useState([]);

  const { updateCart } = useCart();

  useEffect(() => {
    GetcartListDetail();
  }, []);

  const GetcartListDetail = () => {
    setLoading(true);
    GetService(API_URL.GET_CART_LIST).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setCartList(res?.data?.data);
        setCardSummary(res?.data?.summary);
        updateCart(res?.data?.summary?.cartCount);
        localStorage.setItem("count", res?.data?.summary?.cartCount);
        setQuantities(res?.data?.data.map((item) => item?.quantity || 1));
        console.log(res?.data?.data[0]?.Edge);
      }
      setLoading(false);
    });
  };

  const handleCheckout = () => {
    navigate("/checkout");
  };

  const DeleteItem = (id) => {
    setLoading(true);
    PostService(API_URL.DELETE_CART_ITEM, {
      id: id,
      modelName: "user_cart_model",
    }).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        GetcartListDetail();
      }
    });
  };

  const handleIncrease = (index) => {
    setLoading(true);
    setQuantities((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      newQuantities[index] = newQuantities[index] + 1;
      updateQuantity(index, newQuantities[index]);
      return newQuantities;
    });
  };

  const handleDecrease = (index) => {
    setQuantities((prevQuantities) => {
      if (prevQuantities[index] > 1) {
        setLoading(true);
        const newQuantities = [...prevQuantities];
        newQuantities[index] = newQuantities[index] - 1;
        updateQuantity(index, newQuantities[index]);
        return newQuantities;
      }
      return prevQuantities;
    });
  };

  const updateQuantity = async (index, updatedQuantity) => {
    const dataObj = {
      id: CartList[index]?.id,
      price: CartList[index]?.gift_card_Details?.price
        ? CartList[index]?.gift_card_Details?.price
        : CartList[index]?.size_detail?.price,
      quantity: updatedQuantity,
    };
    console.log(dataObj);
    setLoading(true);
    PostService(API_URL.UPDATE_CART_QUANTITY, dataObj).then((res) => {
      console.log(res);
      setLoading(false);
      if (res?.data?.status) {
        GetcartListDetail();
      }
    });

    // try {
    //   // Make your API call here to update the quantity for a specific item
    //   const response = await fetch('your_update_quantity_api_endpoint', {
    //     method: 'PUT',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       // Add any other headers needed for your API
    //     },
    //     body: JSON.stringify({
    //       productId: CartList[index]?.id,
    //       newQuantity: quantities[index],
    //     }),
    //   });

    //   // Check the response status and handle accordingly
    //   if (response.ok) {
    //     console.log(`Quantity for item ${index} updated successfully`);
    //   } else {
    //     console.error(`Failed to update quantity for item ${index}`);
    //   }
    // } catch (error) {
    //   console.error('Error updating quantity:', error);
    // }
  };

  return (
    <div className="enhancements prices prices-one Print checkout">
      <main>
        <section className="cart-area pt-30 pb-50">
          {CartList.length > 0 && (
            <div className="container">
              <div className="cart-heading mb-30 fs-2">Shopping cart</div>
              <div className="row">
                <div className="col-lg-8 col-12 col-md-12  ">
                  <div className="table-content table-responsive AddToShoppingCard first-li">
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="product-thumbnail table-th">
                            Preview
                          </th>
                          <th className="cart-product-name table-th">
                            Product
                          </th>
                          <th className="product-price table-th">Quantity</th>
                          <th className="product-subtotal table-th">Total</th>
                          <th className="product-remove table-th">Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {CartList &&
                          CartList.map((data, index) => (
                            <tr key={index}>
                              {data?.gift_card_Details ? ( 
                                <td className="">
                                <div style={{height:'120px',width:'180px',objectFit:'contain',display:'flex' ,justifyContent:'center'}}>
                                <img
                                  src={ ImageURL + data?.gift_card_Details?.image}
                                  alt=""
                                />
                                </div>
                              </td>
                              ) : (
                                // <td className="product-thumbnail">
                                <td className="">
                                  <div style={{height:'120px',width:'180px',objectFit:'contain',display:'flex' ,justifyContent:'center'}}>
                                  <img
                                    src={ImageURL + data?.MergedImage}
                                    alt=""
                                  />
                                  </div>
                                </td>
                              )}

                              {data?.gift_card_Details ? (
                                <td className="product-name">
                                <ul>
                                  <li className="text-start px-2 py-2 fw-bolder">
                                    {data?.gift_card_Details?.name}
                                  </li>
                                  <li
                                    className="text-start px-2 py-0"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {data?.gift_card_Details?.description}
                                  </li>
                                </ul>
                                </td>
                              ) : (
                                <td className="product-name">
                                  <ul>
                                    <li className="text-start px-2 py-2 fw-bolder">
                                      {" "}
                                      {data?.Layout === "gallery_wall"
                                        ? "Gallery Wall"
                                        : data?.Layout === "story_canvas"
                                        ? "Story Canvas"
                                        : data?.Layout === "split_canvas"
                                        ? "Split Canvas"
                                        : data?.Layout === "single_panel"
                                        ? "Single Canvas"
                                        : data?.Layout === "plexi_print"
                                        ? "Plexi Print"
                                        : data?.Layout === "art_tray"
                                        ? "Art Tray"
                                        : data?.Layout === "wood_print"
                                        ? "Wood Print"
                                        : data?.Layout === "diamond_dust"
                                        ? "Diamond Dust"
                                        : "-"}
                                    </li>
                                    {data?.Layout === "single_panel" && (
                                      <li
                                        className="text-start px-2 py-0"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {data?.type === "framed"
                                          ? "Framed"
                                          : data?.type === "thinGallery"
                                          ? "Thin Gallery Wrap (0.75)"
                                          : data?.type === "thickGallery"
                                          ? "Thick Gallery Wrap (1.5)"
                                          : data?.type === "rolled"
                                          ? "Rolled in a Tube"
                                          : ""}
                                      </li>
                                    )}
                                    {data?.Layout === "split_canvas" && (
                                      <li
                                        className="text-start px-2 py-0"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {data?.size_detail?.panels === 2
                                          ? "DYPTYCHS"
                                          : "TRYPTYCHS"}{" "}
                                        -{" "}
                                        {data?.size_detail?.price
                                          ? "Standard 3/4"
                                          : "Thick 1 1/2"}
                                      </li>
                                    )}
                                    <li className="text-start px-2 py-2">
                                      {" "}
                                      {data?.size_detail?.size}
                                    </li>
                                    {  
                                      data?.Edge &&
                                      JSON.parse(data?.Edge)?.edge && (
                                        <li
                                          className="text-start px-2 py-0"
                                          style={{ fontSize: "13px" }}
                                        >
                                          <label className="fw-bold">
                                            Edge:{" "}
                                          </label>{" "}
                                          {data?.Edge &&
                                            JSON.parse(data?.Edge)?.edge}{" "}
                                          ($
                                          {(data?.Edge &&
                                            JSON.parse(data?.Edge)?.price) ||
                                            0}
                                          )
                                        </li>
                                      )}
                                    {data?.Services &&
                                      JSON.parse(data?.Services)?.Effects
                                        ?.name  && (
                                        <li
                                          className="text-start px-2 py-0"
                                          style={{ fontSize: "13px" }}
                                        >
                                          <label className="fw-bold">
                                            Effects:{" "}
                                          </label>{" "}
                                          {data?.Services &&
                                            JSON.parse(data?.Services)?.Effects
                                              ?.name}{" "}
                                          ($
                                          {(data?.Services &&
                                            JSON.parse(data?.Services)?.Effects
                                              ?.price) ||
                                            0}{" "}
                                          {JSON.parse(data?.Services)?.Effects
                                            ?.name ===
                                            "Textured Canvas Coating" &&
                                            "sq inch"}
                                          )
                                        </li>
                                      )}
                                    {data?.Services &&
                                      JSON.parse(data?.Services)?.Retouching
                                        ?.name  && (
                                        <li
                                          className="text-start px-2 py-0"
                                          style={{ fontSize: "13px" }}
                                        >
                                          <label className="fw-bold">
                                            Retouching:{" "}
                                          </label>{" "}
                                          {data?.Services &&
                                            JSON.parse(data?.Services)
                                              ?.Retouching?.name}{" "}
                                          ($
                                          {(data?.Services &&
                                            JSON.parse(data?.Services)
                                              ?.Retouching?.price) ||
                                            0}
                                          )
                                        </li>
                                      )}
                                  </ul>
                                </td>
                              )}
                              <td className="product-quantity text-center pe-2">
                                <div className="tp-shop-quantity">
                                  <div className="tp-quantity p-relative">
                                    <div
                                      className="qty_button cart-minus tp-cart-minus"
                                      onClick={() =>
                                        handleDecrease(index, data)
                                      }
                                    >
                                      <i className="fal fa-minus" />
                                    </div>
                                    <input
                                      type="text"
                                      value={quantities[index]}
                                      readOnly
                                    />
                                    <div
                                      className="qty_button cart-plus tp-cart-plus"
                                      onClick={() =>
                                        handleIncrease(index, data)
                                      }
                                    >
                                      <i className="fal fa-plus" />
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="product-subtotal">
                                <span className="amount">${data?.price.toLocaleString()}</span>
                              </td>
                              <td className="product-remove">
                                <span
                                  className="pointer"
                                  onClick={() => DeleteItem(data?.id)}
                                >
                                  <i class="fa-regular fa-trash-can border p-1 rounded-1"></i>
                                </span>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4 col-12 col-md-12 AddToShoppingSummery">
                  <div className="box cart-page-total mt-0 p-3">
                    <div className="d-flex justify-content-between">
                      <div className="cart-heading mb-10 ps-1">Summary</div>
                      <div className="text-left">
                        {" "}
                        {CartList.length} Item{CartList.length > 1 ? "s" : ""}
                      </div>
                    </div>
                    <div
                      className="first-li"
                      style={{ overflowX: "auto", maxHeight: "765px" }}
                    >
                      <table class="table">
                        <thead>
                          <tr>
                            <th className="text-black fw-normal fs-6">
                              Product
                            </th>
                            <th className="text-black fw-normal fs-6">Qty</th>
                            <th className="text-black fw-normal fs-6">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {CartList &&
                            CartList.map((data) => (
                              <tr>
                                 {data?.gift_card_Details ? (
                                <td className="product-name"> 
                                <p className="mb-1 fw-semibold">
                                    {data?.gift_card_Details?.name}
                                  </p>
                                  <p
                                      className="mb-1"
                                      style={{ fontSize: "10px" }}
                                    >
                                    {data?.gift_card_Details?.description}
                                  </p> 
                                </td>
                              ) :
                                <td className="p-2">
                                  <p className="mb-1 fw-semibold">
                                    {data?.Layout === "gallery_wall"
                                      ? "Gallery Wall"
                                      : data?.Layout === "story_canvas"
                                      ? "Story Canvas"
                                      : data?.Layout === "split_canvas"
                                      ? "Split Canvas"
                                      : data?.Layout === "single_panel"
                                      ? "Single Canvas"
                                      : data?.Layout === "plexi_print"
                                      ? "Plexi Print"
                                      : data?.Layout === "art_tray"
                                      ? "Art Tray"
                                      : data?.Layout === "wood_print"
                                      ? "Wood Print"
                                      : data?.Layout === "diamond_dust"
                                      ? "Diamond Dust"
                                      : "-"}
                                  </p>
                                  {data?.Layout === "split_canvas" && (
                                    <p
                                      className="mb-1"
                                      style={{ fontSize: "smaller" }}
                                    >
                                      {data?.size_detail?.panels === 2
                                        ? "DYPTYCHS"
                                        : "TRYPTYCHS"}{" "}
                                      -{" "}
                                      {data?.size_detail?.price
                                        ? "Standard 3/4"
                                        : "Thick 1 1/2"}
                                    </p>
                                  )}

                                  {data?.Layout === "single_panel" && (
                                    <p
                                      className="mb-1"
                                      style={{ fontSize: "smaller" }}
                                    >
                                      {data?.type === "framed"
                                        ? "Framed"
                                        : data?.type === "thinGallery"
                                        ? "Thin Gallery Wrap (0.75)"
                                        : data?.type === "thickGallery"
                                        ? "Thick Gallery Wrap (1.5)"
                                        : data?.type === "rolled"
                                        ? "Rolled in a Tube"
                                        : ""}
                                    </p>
                                  )}
                                  <p className="mb-1">
                                    {data?.size_detail?.size}
                                  </p>
                                  <li
                                    className="mb-1"
                                    style={{ fontSize: "13px" }}
                                  >
                                    <label className=" ">Edge/Services</label>{" "}
                                    (${data?.additionalprice || 0})
                                  </li>
                                </td>
}
                                <td className="p-2 text-center">
                                  {data?.quantity}
                                </td>
                                <td className="p-2">${data?.price.toLocaleString()}</td>
                              </tr> 
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-4">
                      <hr />
                      <ul className="mb-20">
                        {/* <li className="px-2">
                        Subtotal <span>$250.00</span>
                      </li>
                      <li className="p-2">
                        Shipping <span>$50.00</span>
                      </li>{" "}
                      <hr className="m-0" /> */}
                        <li className="px-2 fw-bold">
                          Total{" "}
                          <span className="pr-30">
                            ${Number(CardSummary?.subtotal).toLocaleString()}
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className="tp-header__chat-box">
                      <button
                        className="tp-btn-lg large head w-100 mt-5"
                        onClick={handleCheckout}
                      >
                        Checkout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {CartList.length === 0 && (
            <div
              className="text-center d-flex align-items-center justify-content-center"
              style={{ minHeight: "200px", flexDirection:'column' }}
            >
              {!loading && CartList.length === 0 && (
                // <h1 className="noCard_Item">
                //   There's nothing in your shopping cart yet.
                // </h1>
                <>
                <img src="assets/img/blog/empty_cart1.png" alt="" style={{height:'380px',width:'365px'}}/>
                <h3 className="noCard_Item">There's nothing in your shopping cart yet.</h3>
                </>
              )}
            </div>
          )}
        </section>
        <UpperFooterSlider />
      </main>

      {loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
